import { CardProps } from '@material-ui/core'
import { Card, Description } from './GradientBorderCard.style'

interface GradientBorderCardProps extends Partial<CardProps> {
  borderWidth?: number
  onlyChildren?: boolean
}

const GradientBorderCard = ({
  borderWidth,
  onlyChildren,
  children,
  ...props
}: GradientBorderCardProps) => (
  <Card borderWidth={borderWidth} {...props}>
    {onlyChildren ? children : <Description>{children}</Description>}
  </Card>
)

export default GradientBorderCard
